// src/components/customer/sidebar/CustomerSidebar.jsx
import React, { useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  MdDashboard,
  MdShoppingCart,
  MdFavorite,
  MdNotifications,
  MdMessage,
  MdHelp,
  MdLogout,
  MdOutlineShoppingBag,
} from 'react-icons/md';
import '../../../assets/css/components/customer/customerSidebar/CustomerSidebar.css';
import MyContext from '../../../context/MyContext';

const CustomerSidebar = ({ isCollapsed, isMobileOpen, setIsMobileOpen, isMobile }) => {
  const navigate = useNavigate();
  const { setAuthToken, setIsLoggedIn, setLoggedInCustomer } = useContext(MyContext);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userPassword");
    localStorage.removeItem("loggedInCustomer");
    setAuthToken("");
    setLoggedInCustomer(null);
    setIsLoggedIn(false);
    navigate('/customer/login');
  };

  const handleNavClick = () => {
    if (isMobile) setIsMobileOpen(false);
  };

  const navItems = [
    { icon: MdDashboard, label: 'Dashboard', path: '/customer/dashboard' },
    { icon:MdOutlineShoppingBag, label: 'Orders', path: '/customer/orders' },
    {icon:MdShoppingCart, label:'My Cart',path: '/customer/cart'},
    { icon: MdFavorite, label: 'Wishlist', path: '/customer/wishlist' },
    { icon: MdNotifications, label: 'Notifications', path: '/customer/notifications' },
    { icon: MdMessage, label: 'Messages', path: '/customer/messages' },
    { icon: MdHelp, label: 'Help', path: '/customer/help' },
  ];

  const sidebarClass = [
    'sel-sidebar',
    isMobile ? 'sel-sidebar--mobile' : '',
    isMobile && isMobileOpen ? 'sel-sidebar--mobile-open' : '',
    !isMobile && isCollapsed ? 'sel-sidebar--collapsed' : '',
  ].filter(Boolean).join(' ');

  const showLabel = isMobile ? true : !isCollapsed;

  return (
    <>
      {isMobile && isMobileOpen && (
        <div className="sel-sidebar-overlay" onClick={() => setIsMobileOpen(false)} />
      )}

      <div className={sidebarClass}>
        
        <div
          className={`sel-sidebar__logo ${!showLabel ? 'sel-sidebar__logo--centered' : ''}`}
          onClick={() => {
            if (isMobile) setIsMobileOpen(false);
            navigate('/');
          }}
          style={{ cursor: 'pointer' }}
        >
          <div className="sel-sidebar__logo-icon">K</div>
          {showLabel && (
            <div className="sel-sidebar__logo-text">
              <h4>Kisaan Mart</h4>
              <p>Customer Panel</p>
            </div>
          )}
        </div>

        <nav className="sel-sidebar__nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.path} className="sel-sidebar__nav-item">
                <NavLink
                  to={item.path}
                  className="sel-sidebar__nav-link"
                  onClick={() => handleNavClick()}
                  title={!showLabel ? item.label : ''}
                >
                  <span className="sel-sidebar__nav-icon"><Icon /></span>
                  {showLabel && <span className="sel-sidebar__nav-label">{item.label}</span>}
                </NavLink>
              </div>
            );
          })}
        </nav>

        <button className="sel-sidebar__logout" onClick={() => handleLogout()}>
          <span className="sel-sidebar__nav-icon"><MdLogout /></span>
          {showLabel && <span>Logout</span>}
        </button>

      </div>
    </>
  );
};

export default CustomerSidebar;
